import type { QltAvatar } from '../../api/types';

/** The roster thumbnail when the server made one, else the full photo, else null for the placeholder. */
export function avatarSrc(avatar: QltAvatar | null | undefined): string | null {
  if (!avatar) return null;
  const thumb = typeof avatar.thumbnailUrl === 'string' ? avatar.thumbnailUrl.trim() : '';
  if (thumb) return thumb;
  const url = typeof avatar.url === 'string' ? avatar.url.trim() : '';
  return url || null;
}
